import React, { useState, useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { isError } from "../../state/helpers/Error"
import AssignmentRuleService from "../../state/assignment-rule/AssignmentRuleService"
import AssignmentRule from "../../state/assignment-rule/AssignmentRule"
import AssignmentRuleComponent from "./AssignmentRuleComponent"

const AssignmentRulesContainer = () => {

    const [assignmentRules, setAssigmentRules] = useState<AssignmentRule[]>([])

    useEffect(() => {
        AssignmentRuleService.RetrieveGlobalAssignmentRules().then(res => {
            if (!isError(res)) {
                setAssigmentRules(res.filter(ar => ar.isEnabled()))
            }
        })
    }, [])

    if (assignmentRules.length === 0) {
        return <></>
    }

    return <div>
        <div className="row ui-has-modules">
            <label className="col-3 col-form-label text-align-right">
                <FormattedMessage
                    id="setting.automation.assign_rules_label"
                    defaultMessage="Assignment rules"
                />
            </label>
            <div className="col-9 d-flex align-items-center flex-wrap">
                {assignmentRules.map((ar, i) => {
                    return <AssignmentRuleComponent key={i} assignmentRule={ar} />
                })}
            </div>
        </div>
    </div>
}



export default AssignmentRulesContainer


// WEBPACK FOOTER //
// ./src/automation/components/AssignmentRuleContainer.tsx